import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, inject, Input, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { PathFinderService } from 'src/app/services/pathfinder/path-finder.service';
import { UserSettingsService } from 'src/app/services/user-settings/user-settings.service';
import { MapComponent } from 'src/app/shared/components/map/map.component';
import { TextDividerComponent } from 'src/app/shared/components/text-divider/text-divider.component';
import { allPortalKinds, allPvpCategories, validMapCategories } from 'src/app/shared/models/pathfinder.models';

@Component({
  selector: 'app-map-settings',
  imports: [
    CommonModule,
    MatButtonModule,
    TextDividerComponent,
    FormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatSelectModule,
    MatInputModule,
    NgxMatSelectSearchModule,
  ],
  templateUrl: './map-settings.component.html',
  styleUrl: './map-settings.component.scss',
})
export class MapSettingsComponent {
  @Input({ required: true }) mapComponent?: MapComponent;
  disableSaveConfig = signal(false);
  userSettingsService = inject(UserSettingsService);
  pathfinderService = inject(PathFinderService);
  cdr = inject(ChangeDetectorRef);
  portalKinds = allPortalKinds;
  pvpCategories = allPvpCategories;
  mapCategories = validMapCategories;
  filteredMapsNames: string[] = [];

  constructor() {
    this.userSettingsService.afmUser$.subscribe((user) => {
      if (user) {
        this.cdr.markForCheck();
      }
    });
  }
  async ngAfterViewInit(): Promise<void> {
    await this.pathfinderService.initialize();
    this.filteredMapsNames = [...this.pathfinderService.validClustersNames];
  }
  public savePathfinderConfig(): void {
    this.disableSaveConfig.set(true);
    this.userSettingsService.updateUserPathfinderConfig(this.userSettingsService.getUserPathfinderConfig());
    setTimeout(() => {
      this.disableSaveConfig.set(false);
    }, 1000);
  }

  filterClustersNames(value: string) {
    if (!value) {
      // If there is no search value, reset the filtered options to show all options
      this.filteredMapsNames = [...this.pathfinderService.validClustersNames];
    } else {
      // If there is a search value, filter the options array
      this.filteredMapsNames = [...this.pathfinderService.validClustersNames].filter((cluster) => cluster.toLowerCase().includes(value.toLowerCase()));
    }
  }

  settingsChanged() {
    this.mapComponent?.processPath();
  }
}
